exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.add-pet-link[data-v-31afdecd] {\n  padding-top: 40px;\n  text-align: right;\n  text-decoration: underline;\n}\n", "", {"version":3,"sources":["/Users/fabianspring/Documents/projects/omyfu/omyfu-spa-vue/src/components/funeral/music/MusicsComponent.vue"],"names":[],"mappings":";AAyCA;EACI,kBAAiB;EACjB,kBAAiB;EACjB,2BAA0B;CAC7B","file":"MusicsComponent.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.add-pet-link {\n    padding-top: 40px;\n    text-align: right;\n    text-decoration: underline;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-31afdecd","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/funeral/music/MusicsComponent.vue
// module id = iNn7
// module chunks = 1